import { Button, Grid, Typography } from "@mui/material"
import animationFinger from "../../../assets/animation/finger.json"
import Lottie from "react-lottie";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useAuth from "../../../context/auth";

const fingerOptions = {
    loop: true,
    autoplay: true,
    animationData: animationFinger,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
}

export const OrderPending = () => {
    const { getData } = useAuth()
    const navigate = useNavigate()

    useEffect(() => {
        setTimeout(() => {
            navigate("/cliente")
            getData()
        }, 20000);
    }, [])

    return (
        <Grid
            sx={{
                height: "calc(100vh - 12.5rem)",
                display: "flex",
                flexDirection: "column",
                gap: "3rem",
                alignItems: "center",
                justifyContent: "center"
            }}
        >
            <div style={{ width: 254, height: 'auto', marginBottom: '-4rem' }}>
                <Lottie options={fingerOptions} />
            </div>
            <Typography fontWeight={700} fontSize={"3.6rem"} textAlign={"center"}>Agora é só aguardar!</Typography>

            <Typography fontWeight={400} fontSize={"1.6rem"} textAlign={"center"} sx={{ opacity: .5 }}>Já estamos analisando seu pedido!

                Lhe avisaremos assim que finalizarmos a análise.</Typography>
            <Button
                variant="outlined"
                sx={{
                    fontWeight: "500",
                    maxWidth: "32.7rem",
                    height: "5rem",
                    borderColor: "#79747E"
                }}
                onClick={() => {
                    navigate("/cliente")
                    getData()
                }}
            >
                Voltar para tela inicial
            </Button>

        </Grid>
    )
}